/**
 * DevPage
 * This is DevPage API contract
 *
 * OpenAPI spec version: 1.1.0
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AdCategories } from '../model/adCategories';
import { CreateAdCategoryRequest } from '../model/createAdCategoryRequest';
import { ErrorResponse } from '../model/errorResponse';
import { UpdateAdCategoryRequest } from '../model/updateAdCategoryRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class AdvertisementCategoryService {

    protected basePath = 'http://localhost:8090';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param createAdCategoryRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createAdCategory(createAdCategoryRequest: CreateAdCategoryRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public createAdCategory(createAdCategoryRequest: CreateAdCategoryRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public createAdCategory(createAdCategoryRequest: CreateAdCategoryRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public createAdCategory(createAdCategoryRequest: CreateAdCategoryRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (createAdCategoryRequest === null || createAdCategoryRequest === undefined) {
            throw new Error('Required parameter createAdCategoryRequest was null or undefined when calling createAdCategory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/advertisement/category`,
            createAdCategoryRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAdCategories(observe?: 'body', reportProgress?: boolean): Observable<AdCategories>;
    public getAdCategories(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdCategories>>;
    public getAdCategories(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdCategories>>;
    public getAdCategories(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<AdCategories>(`${this.configuration.basePath}/advertisement/category`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param categoryId 
     * @param updateAdCategoryRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCategory(categoryId: string, updateAdCategoryRequest: UpdateAdCategoryRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateCategory(categoryId: string, updateAdCategoryRequest: UpdateAdCategoryRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateCategory(categoryId: string, updateAdCategoryRequest: UpdateAdCategoryRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateCategory(categoryId: string, updateAdCategoryRequest: UpdateAdCategoryRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling updateCategory.');
        }
        if (updateAdCategoryRequest === null || updateAdCategoryRequest === undefined) {
            throw new Error('Required parameter updateAdCategoryRequest was null or undefined when calling updateCategory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/advertisement/category/${encodeURIComponent(String(categoryId))}`,
            updateAdCategoryRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
